/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/Accordion';
import AccordionComponent from '../components/AccordionComponent';
import AccountGeneratorComponent from '../components/AccountGeneratorComponent';
import AwardsListing from '../components/AwardsListing';
import BranchesAndATMs from '../components/BranchesAndATMs';
import BulletPointListing2 from '../components/BulletPointListing2';
import BulletPointListingComponent from '../components/BulletPointListingComponent';
import BusinessCard from '../components/BusinessCard';
import ButtonComponent from '../components/ButtonComponent';
import CardDigitalVar1Component from '../components/CardDigitalVar1Component';
import CardExtensionLimit from '../components/CardExtensionLimit';
import CardListingNoCTA from '../components/CardListingNoCTA';
import CardLogoDescription from '../components/CardLogoDescription';
import CardsListComponent from '../components/CardsListComponent';
import CardsListingComponent from '../components/CardsListingComponent';
import CardsReward from '../components/CardsReward';
import CardsTable from '../components/CardsTable';
import CarLoanCalculator from '../components/CarLoanCalculator';
import CarouselNewsComponent from '../components/CarouselNewsComponent';
import CarouselWithClickableCardsComponent from '../components/CarouselWithClickableCardsComponent';
import CarouselWithInformativeCards from '../components/CarouselWithInformativeCards';
import Chart from '../components/Chart';
import ColumnsSplitter from '../components/ColumnsSplitter';
import Container from '../components/Container';
import Content from '../components/Content';
import CrossSellingProductsComponent from '../components/CrossSellingProductsComponent';
import CustomCheckbox from '../components/CustomCheckbox';
import DebtBurdenRatioCalculator from '../components/DebtBurdenRatioCalculator';
import DocumentComponent from '../components/DocumentComponent';
import DocumentSubmissionForm from '../components/DocumentSubmissionForm';
import DownloadFABComponent from '../components/DownloadFABComponent';
import EditTravelDates from '../components/EditTravelDates';
import EditTravelReferenceNumber from '../components/EditTravelReferenceNumber';
import EligibilityComponent from '../components/EligibilityComponent';
import EligibleCardComponent from '../components/EligibleCardComponent';
import EligibleCardsComponent from '../components/EligibleCardsComponent';
import FAQTopicsCards from '../components/FAQTopicsCards';
import FlippingCard from '../components/FlippingCard';
import FooterComponent from '../components/FooterComponent';
import GalleryComponent from '../components/GalleryComponent';
import GlobalMessageComponent from '../components/GlobalMessageComponent';
import GradientBox from '../components/GradientBox';
import HeaderBannerCards from '../components/HeaderBannerCards';
import HeaderBannerDigitalBankingComponent from '../components/HeaderBannerDigitalBankingComponent';
import HeaderBannerLandingComponent from '../components/HeaderBannerLandingComponent';
import HeaderBannerOfferDetailedComponent from '../components/HeaderBannerOfferDetailedComponent';
import HeaderCasaComponent from '../components/HeaderCasaComponent';
import HeaderComponent from '../components/HeaderComponent';
import IBANGeneratorComponent from '../components/IBANGeneratorComponent';
import InfographicList1 from '../components/InfographicList1';
import InfographicNumberCards from '../components/InfographicNumberCards';
import InfographicNumbers from '../components/InfographicNumbers';
import InPageBanner from '../components/InPageBanner';
import InputWithButton from '../components/InputWithButton';
import Insights from '../components/Insights';
import InternationalLimitForm from '../components/InternationalLimitForm';
import LifestyleCalculator from '../components/LifestyleCalculator';
import LogoListing from '../components/LogoListing';
import ManagementTeamComponent from '../components/ManagementTeamComponent';
import MortgageCalculator from '../components/MortgageCalculator';
import MostRecentOffersComponent from '../components/MostRecentOffersComponent';
import MostViewedOffersComponent from '../components/MostViewedOffersComponent';
import NeedFurtherHelp from '../components/NeedFurtherHelp';
import OfferCardGridItemComponent from '../components/OfferCardGridItemComponent';
import OfferCategoriesBannerComponent from '../components/OfferCategoriesBannerComponent';
import OfferList from '../components/OfferList';
import OfferLocationCardComponent from '../components/OfferLocationCardComponent';
import OfferLocationCardListComponent from '../components/OfferLocationCardListComponent';
import OffersListingPageComponent from '../components/OffersListingPageComponent';
import PageBannerComponent from '../components/PageBannerComponent';
import PersonalLoanCalculator from '../components/PersonalLoanCalculator';
import PopupComponent from '../components/PopupComponent';
import Promo1 from '../components/Promo1';
import PromoOfferListing1 from '../components/PromoOfferListing1';
import PromotionListComponent from '../components/PromotionListComponent';
import PromotionListWithFilters from '../components/PromotionListWithFilters';
import PromotionsHeaderBanner from '../components/PromotionsHeaderBanner';
import Quote from '../components/Quote';
import RelatedOffersComponent from '../components/RelatedOffersComponent';
import Search from '../components/Search';
import SearchResults from '../components/SearchResults';
import SitecoreFormWrapper from '../components/SitecoreFormWrapper';
import SortableTable from '../components/SortableTable';
import StepperComponent from '../components/StepperComponent';
import StickyComponent from '../components/StickyComponent';
import StickyNavigation from '../components/StickyNavigation';
import SubmitNewApplication from '../components/SubmitNewApplication';
import SubmitTravelDocuments from '../components/SubmitTravelDocuments';
import TabItem from '../components/TabItem';
import TableComponent from '../components/TableComponent';
import Tabs from '../components/Tabs';
import Taxonomy from '../components/Taxonomy';
import ThreeColumns from '../components/ThreeColumns';
import TwoColumns from '../components/TwoColumns';
import TwoColumns2 from '../components/TwoColumns2';
import Typo1 from '../components/Typo1';
import Typo2 from '../components/Typo2';
import VideoPlayerComponent from '../components/VideoPlayerComponent';

const components = new Map();
components.set('Accordion', Accordion);
components.set('AccordionComponent', AccordionComponent);
components.set('AccountGeneratorComponent', AccountGeneratorComponent);
components.set('AwardsListing', AwardsListing);
components.set('BranchesAndATMs', BranchesAndATMs);
components.set('BulletPointListing2', BulletPointListing2);
components.set('BulletPointListingComponent', BulletPointListingComponent);
components.set('BusinessCard', BusinessCard);
components.set('ButtonComponent', ButtonComponent);
components.set('CardDigitalVar1Component', CardDigitalVar1Component);
components.set('CardExtensionLimit', CardExtensionLimit);
components.set('CardListingNoCTA', CardListingNoCTA);
components.set('CardLogoDescription', CardLogoDescription);
components.set('CardsListComponent', CardsListComponent);
components.set('CardsListingComponent', CardsListingComponent);
components.set('CardsReward', CardsReward);
components.set('CardsTable', CardsTable);
components.set('CarLoanCalculator', CarLoanCalculator);
components.set('CarouselNewsComponent', CarouselNewsComponent);
components.set('CarouselWithClickableCardsComponent', CarouselWithClickableCardsComponent);
components.set('CarouselWithInformativeCards', CarouselWithInformativeCards);
components.set('Chart', Chart);
components.set('ColumnsSplitter', ColumnsSplitter);
components.set('Container', Container);
components.set('Content', Content);
components.set('CrossSellingProductsComponent', CrossSellingProductsComponent);
components.set('CustomCheckbox', CustomCheckbox);
components.set('DebtBurdenRatioCalculator', DebtBurdenRatioCalculator);
components.set('DocumentComponent', DocumentComponent);
components.set('DocumentSubmissionForm', DocumentSubmissionForm);
components.set('DownloadFABComponent', DownloadFABComponent);
components.set('EditTravelDates', EditTravelDates);
components.set('EditTravelReferenceNumber', EditTravelReferenceNumber);
components.set('EligibilityComponent', EligibilityComponent);
components.set('EligibleCardComponent', EligibleCardComponent);
components.set('EligibleCardsComponent', EligibleCardsComponent);
components.set('FAQTopicsCards', FAQTopicsCards);
components.set('FlippingCard', FlippingCard);
components.set('FooterComponent', FooterComponent);
components.set('GalleryComponent', GalleryComponent);
components.set('GlobalMessageComponent', GlobalMessageComponent);
components.set('GradientBox', GradientBox);
components.set('HeaderBannerCards', HeaderBannerCards);
components.set('HeaderBannerDigitalBankingComponent', HeaderBannerDigitalBankingComponent);
components.set('HeaderBannerLandingComponent', HeaderBannerLandingComponent);
components.set('HeaderBannerOfferDetailedComponent', HeaderBannerOfferDetailedComponent);
components.set('HeaderCasaComponent', HeaderCasaComponent);
components.set('HeaderComponent', HeaderComponent);
components.set('IBANGeneratorComponent', IBANGeneratorComponent);
components.set('InfographicList1', InfographicList1);
components.set('InfographicNumberCards', InfographicNumberCards);
components.set('InfographicNumbers', InfographicNumbers);
components.set('InPageBanner', InPageBanner);
components.set('InputWithButton', InputWithButton);
components.set('Insights', Insights);
components.set('InternationalLimitForm', InternationalLimitForm);
components.set('LifestyleCalculator', LifestyleCalculator);
components.set('LogoListing', LogoListing);
components.set('ManagementTeamComponent', ManagementTeamComponent);
components.set('MortgageCalculator', MortgageCalculator);
components.set('MostRecentOffersComponent', MostRecentOffersComponent);
components.set('MostViewedOffersComponent', MostViewedOffersComponent);
components.set('NeedFurtherHelp', NeedFurtherHelp);
components.set('OfferCardGridItemComponent', OfferCardGridItemComponent);
components.set('OfferCategoriesBannerComponent', OfferCategoriesBannerComponent);
components.set('OfferList', OfferList);
components.set('OfferLocationCardComponent', OfferLocationCardComponent);
components.set('OfferLocationCardListComponent', OfferLocationCardListComponent);
components.set('OffersListingPageComponent', OffersListingPageComponent);
components.set('PageBannerComponent', PageBannerComponent);
components.set('PersonalLoanCalculator', PersonalLoanCalculator);
components.set('PopupComponent', PopupComponent);
components.set('Promo1', Promo1);
components.set('PromoOfferListing1', PromoOfferListing1);
components.set('PromotionListComponent', PromotionListComponent);
components.set('PromotionListWithFilters', PromotionListWithFilters);
components.set('PromotionsHeaderBanner', PromotionsHeaderBanner);
components.set('Quote', Quote);
components.set('RelatedOffersComponent', RelatedOffersComponent);
components.set('Search', Search);
components.set('SearchResults', SearchResults);
components.set('SitecoreFormWrapper', SitecoreFormWrapper);
components.set('SortableTable', SortableTable);
components.set('StepperComponent', StepperComponent);
components.set('StickyComponent', StickyComponent);
components.set('StickyNavigation', StickyNavigation);
components.set('SubmitNewApplication', SubmitNewApplication);
components.set('SubmitTravelDocuments', SubmitTravelDocuments);
components.set('TabItem', TabItem);
components.set('TableComponent', TableComponent);
components.set('Tabs', Tabs);
components.set('Taxonomy', Taxonomy);
components.set('ThreeColumns', ThreeColumns);
components.set('TwoColumns', TwoColumns);
components.set('TwoColumns2', TwoColumns2);
components.set('Typo1', Typo1);
components.set('Typo2', Typo2);
components.set('VideoPlayerComponent', VideoPlayerComponent);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
